import React, { useState, useEffect } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { KTIcon } from '../../_metronic/helpers';
import { getValueFromResource } from '../../common/timeLiveFunction';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (reason: string) => void;
}

const ChangelogReasonModal: React.FC<Props> = ({ isOpen, onClose, onSubmit }) => {
    const dispatch = useAppDispatch();
    const t = (key: string) => key;
    const [modalCommentText, setModalCommentText] = useState('');

    useEffect(() => {
        if (isOpen) {
            setModalCommentText('');
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleSaveModalComment = () => {
        if (!modalCommentText.trim()) return;
        onSubmit(modalCommentText);
        setModalCommentText('');
    };

    return (
        <div className="modal fade show d-block drawer-overlay" tabIndex={-1} id="commentModal" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content rounded">

                    <div className="modal-header pb-2 text-start">
                        <h5 className="headerTitle m-0">
                            {getValueFromResource('Reason', dispatch, t) || 'Reason'}
                        </h5>
                        <div
                            className="btn btn-sm btn-icon btn-active-color-primary"
                            onClick={onClose}
                        >
                            <KTIcon iconName="cross" className="fs-1" />
                        </div>
                    </div>

                    <div className="modal-body pt-3 pb-4 px-4">
                        <p className="text-gray-700 required fs-6 mb-3 text-start">
                            {getValueFromResource('Please enter reason for change', dispatch, t) || 'Please enter reason for change'}
                        </p>
                        <textarea
                            className="form-row form-control"

                            rows={4}
                            placeholder={getValueFromResource('Enter reason...', dispatch, t) || 'Enter reason...'}
                            value={modalCommentText}
                            onChange={(e) => setModalCommentText(e.target.value)}
                            style={{ borderRadius: 2 }}
                            autoFocus
                        />
                    </div>
                    <div className="modal-footer py-4 justify-content-end">
                        <button
                            type="button"
                            className="btn comment-cancel-btn"
                            onClick={onClose}
                        >
                            {getValueFromResource('Cancel', dispatch, t) || 'Cancel'}
                        </button>

                       <span
                            style={{
                                display: "inline-block",
                                cursor: !modalCommentText.trim() ? "not-allowed" : "default"
                            }}
                        >
                            <button
                                type="button"
                                className="btn comment-ok-btn"
                                disabled={!modalCommentText.trim()}
                                onClick={handleSaveModalComment}
                                style={{
                                    opacity: !modalCommentText.trim() ? 0.45 : 1,
                                    pointerEvents: !modalCommentText.trim() ? "none" : "auto"
                                }}
                            >
                                {getValueFromResource('Ok', dispatch, t) || 'Ok'}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangelogReasonModal;